export class Line {
points;
d;
done;
alpha;
color;
size;
startT;
end;
opts;
start;
life;

  constructor(size, color,alpha,opts,start0) {
    this.points = [];
    this.d='';
    this.dv='';
    this.startT=Date.now();
    this.life=0;
    this.start=Date.now() - start0;
    this.opts=opts;
  }
  clone =()=>{
const ll= new Line(this.size,this.color,this.alpha,this.start);
ll.done=this.done;
ll.startT= this.startT;
ll.start=this.start;
ll.d=this.d;
ll.end=this.end;
ll.points=this.points;
ll.life=this.life;
ll.opts=this.opts;
return ll;

  }
}

export class LinesC {

  lines;

  constructor() {
    this.lines = [];

  }
}
